import { render, staticRenderFns } from "./detailes2.vue?vue&type=template&id=4a721f45&scoped=true&"
import script from "./detailes2.vue?vue&type=script&lang=js&"
export * from "./detailes2.vue?vue&type=script&lang=js&"
import style0 from "./detailes2.vue?vue&type=style&index=0&id=4a721f45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a721f45",
  null
  
)

export default component.exports